module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Wardrobe_RGB_lr.3b36ca8e.jpg";